export const buildChartsRequestMessage = (questions: string[]): string =>
  [
    "Build charts for these KPIs:",
    ...questions.map((question, index) => `${index + 1}. ${question}`),
  ].join("\n");
